(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/param-parser.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/param-parser.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function closestDraw(product) {
  const _svs$numbergames$draw = svs.numbergames.draws.drawsUtils.sortProductsByDrawTime(product),
    _svs$numbergames$draw2 = _slicedToArray(_svs$numbergames$draw, 1),
    first = _svs$numbergames$draw2[0];
  return first ? [first.productItsId] : [];
}
svs.numbergames.game_model.utils.paramParser = () => {
  const RETURN_OBJECT = {};
  const FUNCTION_MAP = {};
  const rules = svs.numbergames.game_model.rulesRadio.request('rules');
  const SUBSCRIPTION_PARAM = 'prenumerera';
  const SUBSCRIPTION_VALUE = 'subscription';
  const PARAM_MAP = {
    ROWS: 'rader',
    JOKER: 'joker',
    DAY: 'dag',
    MULTI: 'multi',
    DRAW_COUNT: 'dragningar'
  };
  const _svs$numbergames$prod = svs.numbergames.productMapping.CONSTANTS,
    EUROJACKPOT = _svs$numbergames$prod.EUROJACKPOT,
    EUROJACKPOT_TUESDAY = _svs$numbergames$prod.EUROJACKPOT_TUESDAY,
    EUROJACKPOT_FRIDAY = _svs$numbergames$prod.EUROJACKPOT_FRIDAY,
    LOTTO = _svs$numbergames$prod.LOTTO,
    LOTTO_WEDNESDAY = _svs$numbergames$prod.LOTTO_WEDNESDAY,
    LOTTO_SATURDAY = _svs$numbergames$prod.LOTTO_SATURDAY;
  FUNCTION_MAP[PARAM_MAP.ROWS] = value => {
    value = parseInt(value, 10);
    if (value > 0 && value <= rules.maxNumberOfRows) RETURN_OBJECT.preHuxfluxed = value;
  };
  FUNCTION_MAP[PARAM_MAP.JOKER] = value => {
    if (rules.usesJoker) {
      value = parseInt(value, 10);
      const validPricesArray = svs.numbergames.rules.joker.getJokerPrices();
      if (validPricesArray.indexOf(value) > -1) {
        RETURN_OBJECT.hasJoker = Boolean(value);
        RETURN_OBJECT.jokerPrice = value;
      }
    }
  };
  FUNCTION_MAP[PARAM_MAP.DAY] = value => {
    var _days$value;
    const dayMaps = {
      [EUROJACKPOT]: {
        b: [EUROJACKPOT_TUESDAY, EUROJACKPOT_FRIDAY],
        t: [EUROJACKPOT_TUESDAY],
        f: [EUROJACKPOT_FRIDAY],
        n: closestDraw(EUROJACKPOT)
      },
      [LOTTO]: {
        b: [LOTTO_WEDNESDAY, LOTTO_SATURDAY],
        o: [LOTTO_WEDNESDAY],
        l: [LOTTO_SATURDAY],
        n: closestDraw(LOTTO)
      }
    };
    const days = dayMaps[rules.productId];
    if (days !== null && days !== void 0 && (_days$value = days[value]) !== null && _days$value !== void 0 && _days$value.length) {
      RETURN_OBJECT.selectedDays = days[value];
    }
  };
  FUNCTION_MAP[PARAM_MAP.MULTI] = value => {
    var _rules$rowPriceMulti;
    value = parseInt(value, 10);
    if (value === 1 || ((_rules$rowPriceMulti = rules.rowPriceMulti) === null || _rules$rowPriceMulti === void 0 ? void 0 : _rules$rowPriceMulti.indexOf(value)) > -1) RETURN_OBJECT.rowPriceMulti = value;
  };
  FUNCTION_MAP[PARAM_MAP.DRAW_COUNT] = value => {
    if (value === SUBSCRIPTION_PARAM) {
      RETURN_OBJECT.drawCount = SUBSCRIPTION_VALUE;
    }
    if (rules.possibleDrawCounts.find(draw => draw.value === value)) {
      RETURN_OBJECT.drawCount = value;
    }
  };
  let analyticsAction = '';
  Object.keys(PARAM_MAP).forEach(key => {
    key = PARAM_MAP[key];
    const _svs$utils$paramHandl = svs.utils.paramHandler.get({
        key
      }),
      value = _svs$utils$paramHandl.value;
    if (value) {
      var _FUNCTION_MAP$key;
      analyticsAction = "".concat(analyticsAction).concat(key, "=").concat(value, ";");
      svs.utils.paramHandler.remove({
        key
      });
      (_FUNCTION_MAP$key = FUNCTION_MAP[key]) === null || _FUNCTION_MAP$key === void 0 || _FUNCTION_MAP$key.call(FUNCTION_MAP, value);
    }
  });
  if (analyticsAction.length) {
    const analyticsEvent = {
      category: 'Dynamic Link',
      action: analyticsAction
    };
    svs.components.analytics.trackEvent(analyticsEvent);
  }
  return RETURN_OBJECT;
};

 })(window);